import { useQueryClient } from '@tanstack/react-query';
import { usePostHog } from 'posthog-js/react';


const useLogout = () => {
    const queryClient = useQueryClient();
    const posthog = usePostHog();
    const logout = async () => {
        // 1. Supprimer le token en premier
        localStorage.removeItem(process.env.REACT_APP_TOKEN_NAME);
        // 2. Désactiver toutes les queries globalement — les observers notifiés
        //    par clear() vérifieront enabled:false et ne relancentont rien
        queryClient.setDefaultOptions({ queries: { enabled: false } });
        // 3. Annuler les requêtes en cours
        await queryClient.cancelQueries();
        // 4. Vider le cache
        queryClient.clear();
        posthog.reset();
        window.location.href = '/';
    };

    return logout;
};

export default useLogout;